import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { tap } from 'rxjs';
import { SharedService } from '../../../../../services/shared.service';
import { BroadcastMessageService } from '../../../../../services/broadcast-message.service';
import { MESSAGE } from '../../../../../utils/messages';

@Component({
  selector: 'app-cancel-broadcast-message',
  templateUrl: './cancel-broadcast-message.component.html',
  styleUrls: ['./cancel-broadcast-message.component.scss'],
})
export class CancelBroadcastMessageComponent {
  sending = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: number; infoMessage: string; audioMessage: string },
    public dialogRef: MatDialogRef<CancelBroadcastMessageComponent>,
    private service: BroadcastMessageService,
    private sharedService: SharedService,
  ) {}

  confirm() {
    this.service
      .cancel(this.data.id)
      .pipe(tap(() => (this.sending = true)))
      .subscribe({
        next: () => {
          this.closeDialog();
          this.sending = false;
          this.sharedService.reloadGrid();
          this.sharedService.showSuccessMessage(MESSAGE.success_cancel_broadcast_message);
        },
        error: error => {
          this.sending = false;
          error.errorMessages && error.errorMessages.length
            ? this.sharedService.showMessage(error.appCode)
            : this.sharedService.showMessage(MESSAGE.RUNTIME_ERROR);
        },
      });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
